import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { ReactQueryKey } from "../../types";

export const getCountries = async (): Promise<string[]> => {
    const response = await axios.get('/booking/instool/countries');
    return response.data;
};


export const useCountriesQueryObserver = () => {
    return useQuery<string[]>({
        queryKey: [ReactQueryKey.Countries],
        enabled: false
    })
};

export default getCountries;
